export enum FactoryType {
  Actor = 'actor_factory',
  Animations = 'animations_factory',
  Audio = 'audio_factory',
  Camera = 'camera_factory',
  Controls = 'controls_factory',
  EnvMap = 'env_map_factory',
  Fog = 'fog_factory',
  FsmInstance = 'fsm_instance_factory',
  FsmSource = 'fsm_source_factory',
  IntersectionsWatcher = 'intersections_watcher_factory',
  KeyWatcher = 'key_watcher_factory',
  Light = 'light_factory',
  LoadingManager = 'loading_manager_factory',
  Loop = 'loop_factory',
  Material = 'material_factory',
  Models3d = 'models_3d_factory',
  MouseClickWatcher = 'mouse_click_watcher_factory',
  MousePositionWatcher = 'mouse_position_watcher_factory',
  Particles = 'particles_factory',
  PhysicsBody = 'physics_body_factory',
  Renderer = 'renderer_factory',
  Scene = 'scene_factory',
  Space = 'space_factory',
  SpatialGrid = 'spatial_grid_factory',
  Text = 'text_factory',
  Texture = 'texture_factory',
  TransformDrive = 'transform_drive_factory'
}
